
import React, {FC} from 'react';
import {Modal} from 'react-bootstrap';
import {useScheduler} from 'components/Assistant/_Scheduler/useScheduler';
import {ChatArea} from 'components/Assistant/ChatArea';
import {ChatHints} from 'components/Assistant/ChatHints';
import {ChatSubmit} from 'components/Inputs/ChatSubmit';

import starter from './starter.md';

import * as styles from './styles.module.scss';

type SchedulerModalProps = {
	onHide: () => void
}

export const SchedulerModal: FC<SchedulerModalProps> = ({onHide}) => {
	const {state, send} = useScheduler();
	return (
		<Modal scrollable show size='lg' onHide={onHide}>
			<Modal.Header closeButton className={styles.header}>
				Chat with our booking assistant
			</Modal.Header>
			<Modal.Body>
				<ChatArea
					className={styles.chatArea}
					state={state}
					prompt={starter}
					track='ai:scheduler'
				>
					<ChatHints send={send} hints={[
						'Can you help me find a scan location and time near me?',
						'Do you have any availability next Saturday or Sunday?',
						'Do you have any open times next Thursday afternoon?',
					]} />
				</ChatArea>
			</Modal.Body>
			<Modal.Footer className={styles.footer}>
				<ChatSubmit onSubmit={send}>
					Write your message here
				</ChatSubmit>
			</Modal.Footer>
		</Modal>
	);
};
